import { type GetDocumentVerificationResult } from '@sparrow-card/sparrow-card-constants';
import Api, { FetchMethodType } from './Api';

export default class SocureApi extends Api {
  public async getDocumentVerificationResult({ applicationId }: { applicationId: string }) {
    return this.fetch<GetDocumentVerificationResult>(
      `/document-verification/result/${applicationId}`,
      {
        method: FetchMethodType.GET,
      },
    );
  }
}
